import { headReplace } from '../../../utilities/stringUtil';
import { API } from '../../../utilities/constants';

// クライアント・サーバ処理切替用 差分がある場合はここだけ変更してfabric.eg.jsは同一にする

// API接続先の設定
const basePath = API.nfs;

// 読込時の変換処理
const loadImageSrc = src => {
  // shareの場合にhttp形式に変換する
  return headReplace(src, '/share/', `${basePath}/`);
};

// ToObject,Json化時の変換処理
const exportImageSrc = src => {
  // http形式をshareに戻す
  return headReplace(src, `${basePath}/`, '/share/');
};

export { loadImageSrc, exportImageSrc };



// WEBPACK FOOTER //
// ./src/canvas/common/fabric/fabric.eg.setting.js